import React from 'react';
import { Store,ShoppingCart,Boxes,Truck } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      id: 1,
      icon: null,
      title: "Choose Your Products",
      description: "Browse our wide selection of t-shirts, mugs,  accessories, and more. Find the perfect items for your needs.",
      titleColor: "text-fuchsia-700",
      bgClass: "",
      useImage: false,
      gradientClass: "bg-gradient-to-b from-fuchsia-400 to-fuchsia-600"
    },
    {
      id: 2,
      icon: null,
      title: "Choose the Quantity",
      description: "Select how many items you need. Whether it's one special or bulk orders, we've got you covered.",
      titleColor: "text-orange-500",
      bgClass: "bg-black bg-opacity-50",
      useImage: false,
      gradientClass: "bg-gradient-to-b from-orange-400 to-orange-600"
    },
    {
      id: 3,
      icon: null,
      title: "Order",
      description: "Complete your purchase with our secure checkout process. Add your details and confirm your order.",
      titleColor: "text-purple-500",
      bgClass: "",
      useImage: false,
      gradientClass: "bg-gradient-to-b from-purple-400 to-purple-600"
    },
    {
      id: 4,
      icon: null,
      title: "Print and Deliver",
      description: "We print your products with premium quality materials and ship them fast. Enjoy your items delivered straight to your door.",
      titleColor: "text-blue-500",
      bgClass: "",
      useImage: false,
      gradientClass: "bg-gradient-to-b from-blue-400 to-blue-600"
    }
  ];

  // Products Icon Component (Shopping Bag)
  const ProductsIcon = () => (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-lg"
    >
      <path
        d="M8.33333 12.5H41.6667L37.5 29.1667H12.5L8.33333 12.5Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5 29.1667L10.4167 4.16667H4.16667"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="16.6667"
        cy="41.6667"
        r="2.08333"
        stroke="white"
        strokeWidth="2.5"
        fill="white"
      />
      <circle
        cx="33.3333"
        cy="41.6667"
        r="2.08333"
        stroke="white"
        strokeWidth="2.5"
        fill="white"
      />
      <path
        d="M16.6667 18.75H33.3333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8333 22.9167H29.1667"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // Quantity Icon Component
  const QuantityIcon = () => (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-lg"
    >
      <path
        d="M8.33333 12.5H41.6667L37.5 29.1667H12.5L8.33333 12.5Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5 29.1667L10.4167 4.16667H4.16667"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="16.6667"
        cy="41.6667"
        r="2.08333"
        stroke="white"
        strokeWidth="2.5"
        fill="white"
      />
      <circle
        cx="33.3333"
        cy="41.6667"
        r="2.08333"
        stroke="white"
        strokeWidth="2.5"
        fill="white"
      />
      <text
        x="25"
        y="22"
        textAnchor="middle"
        fill="white"
        fontSize="12"
        fontWeight="bold"
      >
        3
      </text>
    </svg>
  );

  // Order Icon Component
  const OrderIcon = () => (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-lg"
    >
      <path
        d="M10.4167 8.33333H39.5833C40.8889 8.33333 41.6667 9.11111 41.6667 10.4167V39.5833C41.6667 40.8889 40.8889 41.6667 39.5833 41.6667H10.4167C9.11111 41.6667 8.33333 40.8889 8.33333 39.5833V10.4167C8.33333 9.11111 9.11111 8.33333 10.4167 8.33333Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.6667 18.75H33.3333"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 25H33.3333"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 31.25H25"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="35.4167"
        cy="35.4167"
        r="6.25"
        fill="white"
        stroke="white"
        strokeWidth="1"
      />
      <path
        d="M33.3333 35.4167L34.375 36.4583L37.5 33.3333"
        stroke="purple"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // Delivery Icon Component (Truck)
  const DeliveryIcon = () => (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-lg"
    >
      <path
        d="M6.25 31.25H12.5M12.5 31.25C12.5 33.4591 14.2909 35.25 16.5 35.25C18.7091 35.25 20.5 33.4591 20.5 31.25M12.5 31.25C12.5 29.0409 14.2909 27.25 16.5 27.25C18.7091 27.25 20.5 29.0409 20.5 31.25M20.5 31.25H29.5M29.5 31.25C29.5 33.4591 31.2909 35.25 33.5 35.25C35.7091 35.25 37.5 33.4591 37.5 31.25M29.5 31.25C29.5 29.0409 31.2909 27.25 33.5 27.25C35.7091 27.25 37.5 29.0409 37.5 31.25M37.5 31.25H43.75"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 31.25V12.5C6.25 11.8096 6.80964 11.25 7.5 11.25H25C25.6904 11.25 26.25 11.8096 26.25 12.5V31.25"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 18.75H35.4167L43.75 25V31.25H37.5"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 18.75H20.8333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 22.9167H18.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // Enhanced Curved Arrow Component with animations and gradients
  const CurvedArrow = ({ className = "", index = 0 }) => {
    const arrowId = `arrow-gradient-${index}`;
    const pathId = `arrow-path-${index}`;

    return (
      <div className={`hidden lg:flex items-center justify-center ${className}`}>
        <svg
          width="120"
          height="60"
          viewBox="0 0 120 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-lg"
        >
          <defs>
            <linearGradient id={arrowId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#06b6d4" stopOpacity="0.8" />
              <stop offset="50%" stopColor="#3b82f6" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.8" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>

          {/* Main curved path */}
          <path
            id={pathId}
            d="M10 30 Q 35 10 60 30 Q 85 50 110 30"
            stroke={`url(#${arrowId})`}
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            filter="url(#glow)"
            className="animate-pulse"
            style={{
              animation: `flowRight 3s ease-in-out infinite ${index * 0.5}s`
            }}
          />

          {/* Animated dots along the path */}
          <circle r="3" fill={`url(#${arrowId})`} className="opacity-80">
            <animateMotion dur="3s" repeatCount="indefinite" begin={`${index * 0.5}s`}>
              <mpath href={`#${pathId}`} />
            </animateMotion>
          </circle>

          {/* Arrow head with enhanced design */}
          <g transform="translate(110, 30)">
            <path
              d="M-8 -6 L0 0 L-8 6 L-5 0 Z"
              fill={`url(#${arrowId})`}
              stroke={`url(#${arrowId})`}
              strokeWidth="1"
              filter="url(#glow)"
              className="animate-bounce"
              style={{
                animation: `arrowPulse 2s ease-in-out infinite ${index * 0.3}s`
              }}
            />
          </g>

          {/* Decorative sparkles */}
          <circle cx="30" cy="20" r="1.5" fill="#fbbf24" className="animate-ping" style={{ animationDelay: `${index * 0.2}s` }} />
          <circle cx="80" cy="40" r="1" fill="#f59e0b" className="animate-ping" style={{ animationDelay: `${index * 0.4}s` }} />
        </svg>

        <style jsx>{`
          @keyframes flowRight {
            0% { stroke-dasharray: 0 100; }
            50% { stroke-dasharray: 50 50; }
            100% { stroke-dasharray: 100 0; }
          }

          @keyframes arrowPulse {
            0%, 100% { transform: scale(1); opacity: 0.8; }
            50% { transform: scale(1.2); opacity: 1; }
          }
        `}</style>
      </div>
    );
  };

  // Enhanced Mobile Arrow Component
  const MobileArrow = ({ index = 0 }) => {
    const arrowId = `mobile-arrow-gradient-${index}`;
    const pathId = `mobile-arrow-path-${index}`;

    return (
      <div className="flex lg:hidden items-center justify-center py-3">
        <svg
          width="60"
          height="80"
          viewBox="0 0 60 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-lg"
        >
          <defs>
            <linearGradient id={arrowId} x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#06b6d4" stopOpacity="0.8" />
              <stop offset="50%" stopColor="#3b82f6" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.8" />
            </linearGradient>
            <filter id="mobile-glow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>

          {/* Main curved path */}
          <path
            id={pathId}
            d="M30 10 Q 45 25 30 40 Q 15 55 30 70"
            stroke={`url(#${arrowId})`}
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            filter="url(#mobile-glow)"
            style={{
              animation: `flowDown 3s ease-in-out infinite ${index * 0.5}s`
            }}
          />

          {/* Animated dots along the path */}
          <circle r="2.5" fill={`url(#${arrowId})`} className="opacity-80">
            <animateMotion dur="3s" repeatCount="indefinite" begin={`${index * 0.5}s`}>
              <mpath href={`#${pathId}`} />
            </animateMotion>
          </circle>

          {/* Arrow head */}
          <g transform="translate(30, 70)">
            <path
              d="M-6 -8 L0 0 L6 -8 L0 -5 Z"
              fill={`url(#${arrowId})`}
              stroke={`url(#${arrowId})`}
              strokeWidth="1"
              filter="url(#mobile-glow)"
              style={{
                animation: `arrowPulse 2s ease-in-out infinite ${index * 0.3}s`
              }}
            />
          </g>

          {/* Decorative elements */}
          <circle cx="20" cy="25" r="1" fill="#fbbf24" className="animate-ping" style={{ animationDelay: `${index * 0.2}s` }} />
          <circle cx="40" cy="55" r="1.5" fill="#f59e0b" className="animate-ping" style={{ animationDelay: `${index * 0.4}s` }} />
        </svg>

        <style jsx>{`
          @keyframes flowDown {
            0% { stroke-dasharray: 0 100; }
            50% { stroke-dasharray: 50 50; }
            100% { stroke-dasharray: 100 0; }
          }
        `}</style>
      </div>
    );
  };

  // Floating particles background effect
  const FloatingParticles = () => (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="absolute w-2 h-2 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full opacity-30"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animation: `float 6s ease-in-out infinite ${i * 1}s`
          }}
        />
      ))}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-20px) rotate(120deg); }
          66% { transform: translateY(10px) rotate(240deg); }
        }
      `}</style>
    </div>
  );

  // Render icon based on step configuration
  const renderStepIcon = (step) => {
    // All steps now use gradient backgrounds and custom icons
    const getIconComponent = () => {
      switch (step.id) {
        case 1:
          return <Store className='w-10 h-10' />;
        case 2:
          return <ShoppingCart className='w-10 h-10' />;
        case 3:
          return <Boxes className='w-10 h-10' />;
        case 4:
          return <Truck className='w-10 h-10' />;
        default:
          return <ProductsIcon />;
      }
    };

    return (
      <div className={`flex flex-col justify-center  items-center text-white rounded-3xl ${step.gradientClass} h-[94px] w-[94px] shadow-xl border-2 border-white/20`}>
        {getIconComponent()}
      </div>
    );
  };

  return (
    <section className="relative flex flex-col justify-center self-center px-6 md:px-12 py-6 mt-5 max-w-full bg-gradient-to-br from-teal-900 via-teal-800 to-cyan-900 rounded-[40px] w-full max-w-[1400px] mx-auto overflow-hidden">
      <FloatingParticles />

      <div className="relative flex flex-col w-full min-h-[373px] max-md:max-w-full">
        {/* Enhanced Header Section */}
        <div className="self-center text-center max-w-full mb-8 max-md:mb-10 relative z-10">
          <h2 className="text-6xl font-semibold leading-tight text-neutral-100 max-md:max-w-full max-md:text-4xl drop-shadow-lg" style={{ fontFamily: 'Gloock, serif' }}>
            How It Works
          </h2>
          <div className="mt-2 w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full"></div>
          <p className="mt-6 text-2xl font-light leading-relaxed text-neutral-300 max-md:font-regular max-md:max-w-full max-md:text-lg">
            Choose your products, select quantity, place your order, and get fast delivery
          </p>
        </div>

        {/* Steps Container */}
        <div className="w-full relative z-10">
          {/* Desktop Layout */}
          <div className="hidden lg:flex items-start justify-center">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                {/* Step */}
                <div className="flex flex-col items-center text-center max-w-[280px] px-4 transform transition-all duration-300 hover:scale-105">
                  {/* Step Number Badge */}
                  <div className="relative mb-4">
                    <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-gradient-to-r from-white to-gray-100 rounded-full flex items-center justify-center text-teal-900 font-bold text-sm z-10 shadow-lg border-2 border-teal-200">
                      {step.id}
                    </div>

                    {/* Icon Container with enhanced styling */}
                    <div className="relative">
                      {renderStepIcon(step)}
                    </div>
                  </div>

                  {/* Step Content */}
                  <div className={`text-md font-semibold mb-3 ${step.titleColor} drop-shadow-sm title-with-white-stroke`}>
                    {step.title}
                  </div>
                  <div className="text-sm font-light leading-5 text-neutral-200 drop-shadow-sm">
                    {step.description}
                  </div>
                </div>

                {/* Enhanced Curved Arrow (except after last step) */}
                {index < steps.length - 1 && (
                  <CurvedArrow className="mx-2 mt-12" index={index} />
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Tablet Layout */}
          <div className="hidden md:grid lg:hidden grid-cols-2 gap-8 max-w-4xl mx-auto">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <div className="flex flex-col items-center text-center transform transition-all duration-300 hover:scale-105">
                  {/* Step Number Badge */}
                  <div className="relative mb-4">
                    <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-gradient-to-r from-white to-gray-100 rounded-full flex items-center justify-center text-teal-900 font-bold text-sm z-10 shadow-lg border-2 border-teal-200">
                      {step.id}
                    </div>

                    {/* Icon Container */}
                    <div className="relative">
                      {renderStepIcon(step)}
                    </div>
                  </div>

                  {/* Step Content */}
                  <div className={`text-sm font-semibold mb-3 ${step.titleColor} drop-shadow-sm title-with-white-stroke`}>
                    {step.title}
                  </div>
                  <div className="text-xs font-light leading-5 text-neutral-200 drop-shadow-sm">
                    {step.description}
                  </div>
                </div>

                {/* Enhanced Mobile Arrow between rows */}
                {index > steps.length - 1  && (
                  <div className="col-span-2 flex justify-center">
                    <MobileArrow index={index} />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Mobile Layout */}
          <div className="flex md:hidden flex-col items-center space-y-8 max-w-sm mx-auto">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <div className="flex flex-col items-center text-center w-full transform transition-all duration-300 hover:scale-105">
                  {/* Step Number Badge */}
                  <div className="relative mb-4">
                    <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-gradient-to-r from-white to-gray-100 rounded-full flex items-center justify-center text-teal-900 font-bold text-sm z-10 shadow-lg border-2 border-teal-200">
                      {step.id}
                    </div>

                    {/* Icon Container */}
                    <div className="relative">
                      {renderStepIcon(step)}
                    </div>
                  </div>

                  {/* Step Content */}
                  <div className={`text-sm font-semibold mb-3 ${step.titleColor} drop-shadow-sm title-with-white-stroke`}>
                    {step.title}
                  </div>
                  <div className="text-xs font-light leading-5 text-neutral-200 px-4 drop-shadow-sm">
                    {step.description}
                  </div>
                </div>

                {/* Enhanced Mobile Arrow (except after last step) */}
               {index < steps.length - 1 && (
                  <MobileArrow index={index} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .title-with-white-stroke {
          -webkit-text-stroke-width: 0.25px;
          -webkit-text-stroke-color: #fff;
          text-stroke-width: 0.25px;
          text-stroke-color: #fff;
        }

        .title-with-white-stroke.text-fuchsia-700 {
          color: #a21caf !important;
        }

        .title-with-white-stroke.text-orange-500 {
          color: #f97316 !important;
        }

        .title-with-white-stroke.text-purple-500 {
          color: #a855f7 !important;
        }

        .title-with-white-stroke.text-blue-500 {
          color: #3b82f6 !important;
        }
      `}</style>
    </section>
  );
};

export default ProcessSteps;
